import { FunctionComponent, useMemo } from "react";
import { DesktopBetslipProps } from "./snowflakes/DesktopBetslip/DesktopBetslip.types";
import { ModalBetslipProps } from "./ModalBetslip/ModalBetslip.types";
import { ComponentProps } from "./props";
import { ModalBetslip } from "./ModalBetslip/ModalBetslip.web";
import { DesktopBetslip } from "./snowflakes/DesktopBetslip/DesktopBetslip.web";
import { RootBetslipContextProvider } from "./RootBetslipContext";
import { KeyboardProvider } from "../Keyboard/KeyboardContext";
import { SportsbookBetslipContextProvider } from "../../context/sportsbook";

const RootBetslip: FunctionComponent<ComponentProps> = (props) => {
  const {
    isCollapsed,
    hasMultiples,
    hasConfirmation,
    activeProduct,
    step,
    isClosed,
    activeBetslipType,
    quickBetslipBet,
    isReceiptReusePending,
    dispatchHeaderToggle,
    dispatchDismissClick,
    contract,
  } = props;

  const { isDesktopLayout } = contract.config;

  const betslipContent = useMemo(() => {
    const modalBetslipProps: ModalBetslipProps = {
      quickBetslipBet,
      hasMultiples,
      hasConfirmation,
      activeProduct,
      step,
      isClosed,
      isCollapsed,
      activeBetslipType,
      dispatchHeaderToggle,
      dispatchDismissClick,
    };

    const desktopBetslipProps: DesktopBetslipProps = {
      activeBetslipType,
      step,
      hasConfirmation,
      onClose: step === "REPORT" ? dispatchDismissClick : undefined,
    };

    return isDesktopLayout ? (
      <DesktopBetslip {...desktopBetslipProps} />
    ) : (
      <ModalBetslip {...modalBetslipProps} isReceiptReusePending={isReceiptReusePending} />
    );
  }, [
    quickBetslipBet,
    isReceiptReusePending,
    activeBetslipType,
    activeProduct,
    dispatchDismissClick,
    dispatchHeaderToggle,
    hasConfirmation,
    hasMultiples,
    isClosed,
    isCollapsed,
    isDesktopLayout,
    step,
  ]);

  return (
    <SportsbookBetslipContextProvider value={contract}>
      <RootBetslipContextProvider isCollapsed={isCollapsed}>
        <KeyboardProvider>{betslipContent}</KeyboardProvider>
      </RootBetslipContextProvider>
    </SportsbookBetslipContextProvider>
  );
};

export default RootBetslip;
